import cl from 'classnames';
import { ModelViewerItem } from '../../hooks/useModelViewerEditor/useModelViewerEditor.types';

interface ModelViewerEditorDropZoneProps {
  activeItem: ModelViewerItem;
  isDragging: boolean;
  fileInput: React.RefObject<HTMLInputElement>;
  dropError: string;
  handleDropClick: () => void;
  handleDropInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDrop: (e: React.DragEvent) => void;
  handleDragOver: (e: React.DragEvent) => void;
}

function ModelViewerEditorDropZone({
  activeItem,
  isDragging,
  dropError,
  fileInput,
  handleDropClick,
  handleDropInputChange,
  handleDrop,
  handleDragOver
}: ModelViewerEditorDropZoneProps) {
  return (
    <div
      className={cl('absolute inset-4 bottom-16 p-8', {
        hidden: activeItem?.file && !isDragging
      })}
    >
      <div
        className={cl(
          'w-full h-full flex justify-center items-center text-center border-2 border-dashed rounded-lg transition-all duration-200 cursor-pointer border-gray-600',
          {
            'border-gray-400 bg-gray-400/30': isDragging && !dropError,
            'border-red-400 bg-red-400/20': dropError
          }
        )}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleDropClick}
      >
        <input
          className="hidden"
          ref={fileInput}
          accept=".glb,.gltf"
          type="file"
          onChange={handleDropInputChange}
        />
        {dropError || (
          <div>
            <p>Drag and drop a .glb or .gltf file here</p>
            <p>or click to select a file</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ModelViewerEditorDropZone;
